import { useMemo } from 'react';
import {
  useActiveWorkspaceContext,
  useAuthorizedOutletContext,
} from './router/context';

import { workspaceMethods } from '@synapex/shared2/entities';

export const useActiveUser = () => {
  const { activeUser } = useAuthorizedOutletContext();
  return activeUser;
};

export const useActiveWorkspace = () => {
  const {
    activeAccount,
    activeWorkspace,
    ordData,
    permission,
    subscription,
    owner,
  } = useActiveWorkspaceContext();

  const advertiser_account_id = activeAccount?.advertiser_account_id ?? null;

  const activeAwd = useMemo(
    () => ({
      ...workspaceMethods.getWd(activeWorkspace),
      advertiser_account_id,
    }),
    [activeWorkspace, advertiser_account_id],
  );

  return {
    owner,
    activeAwd,
    ordData,
    permission,
    subscription,
    activeAccount,
    activeWorkspace,
  };
};
